export default class RomaneioConferenciaProduto {
  constructor(id = "", idRomaneio = "", codProduto = "", quantidadeDevolvida = "") {
    this.id = id
    this.idRomaneio = idRomaneio
    this.codProduto = codProduto
    this.quantidadeDevolvida = quantidadeDevolvida
  }
}
